import { api, setToken } from "./api";

export interface LoginResponse {
  token: string;
  username: string;
  role: string;
  expiresInSeconds: number;
}

export interface MeResponse {
  username: string;
  role: string;
}

export async function login(username: string, password: string): Promise<LoginResponse> {
  const result = await api<LoginResponse>("/auth/login", {
    method: "POST",
    body: { username, password },
    auth: false,
  });
  setToken(result.token);
  return result;
}

export async function fetchMe(): Promise<MeResponse> {
  return api<MeResponse>("/auth/me");
}

export function logout(): void {
  setToken(null);
}

export async function changePassword(
  oldPassword: string,
  newPassword: string,
): Promise<{ ok: true }> {
  return api<{ ok: true }>("/auth/change-password", {
    method: "POST",
    body: { oldPassword, newPassword },
  });
}

export interface SsoExchangeResponse {
  token: string;
  username: string;
  role: string;
  expiresInSeconds: number;
}

export async function ssoExchange(hubToken: string): Promise<SsoExchangeResponse> {
  const result = await api<SsoExchangeResponse>("/auth/sso-exchange", {
    method: "POST",
    body: { hubToken },
    auth: false,
  });
  setToken(result.token);
  return result;
}
